import { z } from 'zod';

import type { Address } from '@/models/Address.ts';
import type { ServiceUser } from '@/models/ServiceUser.ts';

export const deviceStatuses = ['ACTIVE', 'INACTIVE', 'MAINTENANCE'] as const;

export const DeviceStatusSchema = z.enum(deviceStatuses);
export type DeviceStatus = z.infer<typeof DeviceStatusSchema>;

const IotcommsDeviceSchema = z.object({
  authType: z.string(),
  deviceId: z.string(),
  password: z.string(),
  deviceType: z.string(),
  description: z.string().nullable().optional(),
});

export const DeviceSchema: z.ZodType<any> = z.lazy(() =>
  z.object({
    id: z.string(),
    name: z.string(),
    type: z.string().nullable().optional(),
    model: z.string().nullable().optional(),
    serialNumber: z.string().nullable().optional(),
    guid: z.string().nullable().optional(),
    location: z.string().nullable().optional(),
    phoneNumber: z.string().nullable().optional(),
    online: z.boolean(),
    status: DeviceStatusSchema,
    address: z.custom<Address>().nullable().optional(),
    manufacturer: z.string().nullable().optional(),
    connectionId: z.string().nullable().optional(),
    parentId: z.string().nullable().optional(),
    schemeId: z.string().nullable().optional(),
    authorityId: z.string().nullable().optional(),
    authorityName: z.string().nullable().optional(),
    schemeName: z.string().nullable().optional(),
    iotcommsDevice: IotcommsDeviceSchema.nullable().optional(),
    sipNumbers: z.array(z.string()),
    isConnection: z.boolean(),
    isIgnorelisted: z.boolean(),
    controllerId: z.string().nullable().optional(),
    organizationId: z.string().nullable().optional(),
    createDate: z.string().nullable().optional(),
    lastUpdateDate: z.string(),
    boundDevices: z.array(z.custom<any>()),
    boundServiceUsers: z.array(z.custom<ServiceUser>()),
  }),
);

export type Device = z.infer<typeof DeviceSchema>;
